define(function(require) {

	var tool = require('toolLoaderPC');

	function generate(total, page, count){

		total = tool.toNumber(total);
		page = tool.toNumber(page);
		count = tool.toNumber(count);

		if (total === 0) {
			return [];
		}

		var res = [],
			pageCount = Math.ceil(total/count),

			start = Math.max(page - 4, 1),
			end = Math.min(start + 8, pageCount),
			dis = end - start,
			_end = Math.min(page + 4, pageCount),
			_start = Math.max(_end - 8, 1),
			_dis = _end - _start;

		if (_dis > dis) {
			start = _start;
			end = _end;
		}

		// 如果起始页不为1页，则显示首页
		if (start!==1) {
			res.push({
				text: '首页',
				target: 1,
				disable: false,
				cur: false
			});
		}

		// 如果当前页不为1，则有上一页
		if (page!==1) {
			res.push({
				text: '上一页',
				target: page - 1,
				disable: false,
				cur: false
			});
		}

		for (var i = start; i <= end; i++) {
			res.push({
				text: ''+i,
				target: i,
				disable: i===page,
				cur: i===page
			});
		}

		// 如果当前页不为最后一页，则有下一页
		if (page!==pageCount) {
			res.push({
				text: '下一页',
				target: page + 1,
				disable: false,
				cur: false
			});
		}

		// 如果结尾页不为最后一页，则有最后一页
		if (end!==pageCount) {
			res.push({
				text: '尾页',
				target: pageCount,
				disable: false,
				cur: false
			});
		}
		
		return res;
	}

	return {
		/**
		 * 分页初始化
		 * @param {Number} total 总条数
		 * @param {Number} page	 当前页
		 * @param {Number} count 每页的条数
		 */
		init: function(total, page, count){
			return generate(total, page, count);
		}
	};
	
});